<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="手机号" v-model="mobile"></el-input>
            </el-col>
            <el-col :span="4">
                <el-select v-model="batch">
                    <el-option value="" label="批号"></el-option>
                    <el-option v-for="x in selectList" :key="x" :value="x" :label="x"></el-option>
                </el-select>
            </el-col>
            <el-col :span="14">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="/sim/card/add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="mobile" label="手机号">
            </el-table-column>
            <el-table-column prop="batch" label="批号">
            </el-table-column>
            <el-table-column prop="ccid" label="CCID">
            </el-table-column>
            <el-table-column prop="imsi" label="IMSI">
            </el-table-column>
            <el-table-column prop="operate.name" label="运营商">
            </el-table-column>
            <el-table-column prop="supplier.name" label="供应商">
            </el-table-column>
            <el-table-column prop="date" label="添加日期">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';

    export default {
        name: 'admin',
        data() {
            return {
                mobile: '',
                batch: '',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                selectList:[],
            }
        },
        created() {
            this.$http.get('/manage/sim/batchList').then(data => {
                this.selectList = data['data']['data'];
            });
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.mobile.trim() != '') {
                    params.mobile = this.mobile;
                }
                if(this.batch.trim() != '') {
                    params.batch = this.batch;
                }
                this.$http.post('/manage/sim/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    this.$http.post('/manage/sim',{id:ID}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                this.$router.push('./edit/'+this.data[index].id);
            },
        },
        components: { Pagination }
    }
</script>